module.exports = __webpack_public_path__ + "static/media/s5.1a514fb5.png";